export default __webpack_public_path__ + "static/media/fet.2aa46807.png";